/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import MarkdownTable from '../components/_atoms/MarkdownTable';
export const meta = {
  author: 'Jens Aarre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  disableHeadline: true,
  mdx: true,
  meta: meta,
  title: "State and District Privacy Agreements",
  subTitle: "State and District Privacy Agreements of using Curipod",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      strong: "strong",
      p: "p",
      h3: "h3",
      a: "a"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        children: _jsx(_components.strong, {
          children: "State and District Privacy Agreements"
        })
      }), "\n", _jsx(_components.p, {
        children: "Curipod abides by federal safety and privacy legislation such as FERPA and COPPA. In addition, we know that many states and districts require a signed data privacy agreement. If your district or state require such a DPA please find the relevant DPA in the list below, and we would be happy to sign it."
      }), "\n", _jsx(_components.p, {
        children: "Student data privacy is one of our top priorities. Do you have any questions or feedback regarding data privacy in Curipod, please reach out directly to our CEO at jens@curipod.com"
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Links to privacy policy agreements by state"
        })
      }), "\n", _jsxs("table", {
        children: [_jsxs("thead", {
          children: [_jsx("th", {
            children: "State"
          }), "\n", _jsx("th", {
            children: "Link to data privacy agreement"
          })]
        }), _jsxs("tbody", {
          children: [_jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Arkansas - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=AR",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=AR"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Arizona - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=ZA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=ZA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "California - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=CA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=CA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Florida - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=FL",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=FL"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Iowa - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=IA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=IA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Illinois - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=IL",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=IL"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Massachusetts - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=MA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=MA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Maine - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=ME",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=ME"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Minnesota - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=MN",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=MN"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Missouri - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=MO",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=MO"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Montana - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=MT",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=MT"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "North Carolina - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=NC",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=NC"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Nebraska - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=NE",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=NE"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "New Hampshire - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=NH",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=NH"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Ohio - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=OH",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=OH"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Oklahoma - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=OK",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=OK"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Oregon - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=OR",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=OR"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Rhode Island - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=RI",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=RI"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Tennessee - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=TN",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=FL"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Texas - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=TX",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=TX"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Utah - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=UT",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=UT"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Virginia - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=VA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=VA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Vermont - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=VT",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=VT"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Washington - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=WA",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=WA"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Wisconsin - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=WI",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=WI"
                })
              })
            })]
          }), _jsxs("tr", {
            children: [_jsx("td", {
              children: _jsx("p", {
                children: "Wyoming - "
              })
            }), _jsx("td", {
              children: _jsx(_components.p, {
                children: _jsx(_components.a, {
                  href: "https://sdpc.a4l.org/view_alliance.php?state=WY",
                  children: "https://sdpc.a4l.org/view_alliance.php?state=WY"
                })
              })
            })]
          })]
        })]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Is your state not on the list?"
        })
      }), "\n", _jsx(_components.p, {
        children: "Don’t worry! Please send an email to jens@curipod.com with the data privacy agreement your district or state is using, and we will happily review it and come back to you promptly."
      })]
    });
  }
}
export default MDXContent;
